import { Component, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from 'src/app/core/service/utils.service';
import { UserServiceService } from 'src/app/pages/users/services/user-service.service';
import { catchError, first, takeUntil, finalize } from 'rxjs/operators';
import { BoardServiceService } from '../../services/board-service.service';
import { FilesServiceService } from '../../services/files-service.service';
import { ModalFilesComponent } from 'src/app/shared/modal-files/modal-files.component';
import { SprintFormComponent } from '../sprint-form/sprint-form.component';
import { BoardMainScreenService } from '../board-main-screen/board-main-screen.service';
import { forkJoin, of, Subject } from 'rxjs';
import { ProjectsServiceService } from '../../services/projects-service.service';
import moment from 'moment';
import { EventModalComponent } from 'src/app/pages/settings/modal-settings/event-modal/event-modal.component';
import { ConfigurationType, ProjectSettingService } from '../../services/project-setting.service';
import { ColumnModalComponent } from 'src/app/pages/settings/modal-settings/column-modal/column-modal.component';
import { isArray } from 'lodash';
@Component({
  selector: 'app-task-form',
  templateUrl: './task-form.component.html',
  styleUrls: ['./task-form.component.scss']
})
export class TaskFormComponent implements OnInit, OnDestroy {

  @ViewChild('sprintForm') sprintForm: SprintFormComponent | null = null;
  @ViewChild('modal', { static: true }) modal: ModalFilesComponent | null = null;
  @ViewChild('modalCreateTask') modalCreateTask?: TemplateRef<NgbModal>;
  @ViewChild('modalEvent') modalEvent: EventModalComponent | null = null;
  @ViewChild('modalPriority') modalPriority: EventModalComponent | null = null;
  @ViewChild('modalColumn') modalColumn: ColumnModalComponent | null = null;
  destroy$: Subject<boolean> = new Subject<boolean>();

  taskForm!: FormGroup;
  columnForm!: FormGroup;
  submittedTask: boolean = false;
  submittedColumn: boolean = false;

  projectId: number = 0;
  taskId: number = 0;
  teamId: number | null = null;
  requirementsList: any = [];
  columnsList: any = [];
  sprintsList: any = [];
  usersList: any = [];
  taskSprintsList: any = [];
  taskColumnsList: any = [];

  typesList: any = [];
  prioritiesList: any = [];
  subTask: boolean = false;
  projectRequest: boolean = false;

  orderTypesList: any = [];

  //Modal Files
  modalRef: NgbModalRef;
  showModal = false;
  showModalRequestFiles = false;
  deleteFiles: any = [];

  minDate: Date;
  maxDate: Date;
  loading: boolean = false;

  constructor(public router: Router,
    public translateService: TranslateService,
    public boardMainScreen: BoardMainScreenService,
    private modalService: NgbModal,
    public utilSrv: UtilsService,
    private userService: UserServiceService,
    private fb: FormBuilder,
    private fileSrv: FilesServiceService,
    private boardService: BoardServiceService,
    private projectService: ProjectsServiceService,
    private settingSrv: ProjectSettingService,
    private route: ActivatedRoute) {
    this.projectId = this.route.snapshot.params.projectId;
    this.projectRequest = localStorage.getItem("projectRequestVersionId") == 'null' ? false : true;



    this.orderTypesList = [
      { label: this.translateService.instant('BOARD.FORM.DEFAULT'), value: -1 },
      { label: this.translateService.instant('BOARD.FORM.ISBEFORE'), value: true },
      { label: this.translateService.instant('BOARD.FORM.ISAFTER'), value: false },
    ]
  }

  ngOnInit(): void {
    this.boardMainScreen.openTaskForm.pipe(
      takeUntil(this.destroy$)
    ).subscribe(value => {
      this.openModal(value)
      this.loadUsers();

    });


  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  setTaskForm() {
    this.taskForm = this.fb.group({
      startDate: [null],
      endDate: [null],
      estimatedDuration: [null],
      priorityId: [null, Validators.required],
      title: ['', Validators.required],
      description: [''],
      typeId: [null, Validators.required],
      columnId: [null],
      requestedBy: [''],
      tags: [[]],
      sprintId: [null],
      bugId: [null],
      supportId: [null],
      plannedTask: [true, Validators.required],
      assignedId: [null],
      projectId: [null],
      requirementId: [null],
      isBefore: [-1],
      taskColumnId: [null],
      taskSprintId: [null],
      uploadFiles: [[]],
      files: [[]],
    });
  }

  get formTask() { return this.taskForm.controls; }
  get formColumn() { return this.columnForm.controls; }

  /*LOAD */

  loadUsers(search?: any, sprintId?: number, memberId?: number) {
    if ((this.formTask.sprintId.value != null && sprintId == null) || (sprintId != null)) {
      this.boardService.getSprintTeamMembers(this.projectId, sprintId ? sprintId : this.formTask.sprintId.value, search == null ? null : search).pipe(first()).subscribe(response => {
        this.usersList = [];
        if (response.data.length > 0) {
          for (let x in response.data) {
            this.usersList.push({ label: response.data[x].user.firstName + ' ' + response.data[x].user.lastName, value: response.data[x].userId });
          }
          if (sprintId && memberId) {
            let valor = response.data.filter((d: any) => d.userId == memberId)
            if (valor.length == 0) {
              this.userService.getMembro(memberId).pipe(first()).subscribe(response => {
                this.usersList.push({ label: response.data[0].user.firstName + ' ' + response.data[0].user.lastName, value: response.data[0].id })
                this.taskForm.patchValue({ assignedId: memberId });
              });
            } else {
              this.taskForm.patchValue({ assignedId: memberId });
            }
          }
        }
        if (this.usersList?.length == 0) {
          this.taskForm.controls.assignedId.disable();
        } else {
          this.taskForm.controls.assignedId.enable();
        }
      }, error => {
        console.error('Load Members', error);
        this.utilSrv.toast(`${this.translateService.instant('USERS.ERRORMEMBERS')}: ${error}`, 'error', false);
      });
    } else {
      this.projectService.getProjectMembers(this.projectId, search == null ? null : search).pipe(first()).subscribe(response => {
        this.usersList = [];
        if (response.data.length > 0) {
          for (let x in response.data) {
            this.usersList.push({ label: response.data[x].firstName + ' ' + response.data[x].lastName, value: response.data[x].id });
          }
          if (memberId) {
            let valor = response.data.filter((d: any) => d.id == memberId)
            if (valor.length == 0) {
              this.userService.getMembro(memberId).pipe(first()).subscribe(response => {
                this.usersList.push({ label: response.data[0].user.firstName + ' ' + response.data[0].user.lastName, value: response.data[0].id })
                this.taskForm.patchValue({ assignedId: memberId });
              });
            } else {
              this.taskForm.patchValue({ assignedId: memberId });
            }
          }
        }
        if (this.usersList?.length == 0) {
          this.taskForm.controls.assignedId.disable();
        } else {
          this.taskForm.controls.assignedId.enable();
        }
      }, error => {
        this.utilSrv.toast(`${this.translateService.instant('USERS.ERRORMEMBERS')}: ${error}`, 'error', false);
      });
    }
  }

  loadRequirements(idRequirement?: number) {
    this.projectService.getRequirements(this.projectId).pipe(first()).subscribe((response) => {
      this.requirementsList = [];
      if (response.data && isArray(response.data)) {
        this.requirementsList = response.data.map((m: any) => ({ ...m, label: m.requirement, value: m.id }));
        if (idRequirement) this.taskForm.patchValue({ requirementId: idRequirement });
      }
    })
  }

  loadColumns(idColumn?: number) {
    this.boardService.getColumnsDrop(this.projectId).pipe(first()).subscribe(response => {
      this.columnsList = [];
      if (response.data && isArray(response.data)) {
        this.columnsList = response.data.map((m: any) => ({ ...m, label: m.name, value: m.id }));
        this.taskForm.patchValue({ columnId: idColumn });
      }
    }, error => {
      console.error('Load Columns', error);
      this.utilSrv.toast(`${this.translateService.instant('BOARD.ERROR.LOADCOLUMNS')} ${error}`, 'error', false);
    });
  }

  loadPriorities(idPriority?: number) {
    this.boardService.getConfigurations(this.projectId, ConfigurationType.PRIORITY)
      .pipe(first())
      .subscribe(response => {
        this.prioritiesList = [];
        if (response.data.length > 0) {
          for (let x in response.data) {
            this.prioritiesList.push({ label: response.data[x].clientDescription, value: response.data[x].id })
          }
          if (idPriority) this.taskForm.patchValue({ priorityId: idPriority });
        }
      }, error => {
        console.error('Load Priorities', error);
        this.utilSrv.toast(`${this.translateService.instant('SETTINGS.PRIORITY.ERRORGET')}: ${error}`, 'error', false);
      });
  }

  loadTypes(idType?: number) {
    this.boardService.getConfigurations(this.projectId, ConfigurationType.TASK)
      .pipe(first())
      .subscribe(response => {
        this.typesList = [];
        if (response.data.length > 0) {
          for (let x in response.data) {
            this.typesList.push({ label: response.data[x].clientDescription, value: response.data[x].id })
          }
          if (idType) this.taskForm.patchValue({ typeId: idType });
        }
      }, error => {
        console.error('Load Types', error);
        this.utilSrv.toast(`${this.translateService.instant('SETTINGS.EVENT.ERRORGETTASK')}: ${error}`, 'error', false);
      });
  }

  loadSprints(idSprint?: number) {
    this.boardService.getSprintsByProject(this.projectId).pipe(first()).subscribe(response => {
      this.sprintsList = [];
      if (response.data.length > 0) {
        for (let x in response.data) {
          this.sprintsList.push({ ...response.data[x], label: response.data[x].name, value: response.data[x].id })
        }
        if (idSprint) {
          this.taskForm.patchValue({ sprintId: idSprint });
          const sprintSelected = this.sprintsList.find((f: any) => f.id === idSprint);
          if (sprintSelected) {
            this.minDate = new Date(sprintSelected.startDate);
            this.maxDate = new Date(sprintSelected.endDate);
          }
        }
      }
    }, error => {
      console.error('Load Sprints', error);
      this.utilSrv.toast(`${this.translateService.instant('BOARD.ERROR.LOADSPRINTS')}: ${error}`, 'error', false);
    });
  }

  loadDataFilters(startDate?: any, endDate?: any) {
    if (startDate && endDate) {
      this.minDate = new Date(startDate);
      this.maxDate = new Date(endDate);
    } else {
      this.boardService.getSprint(this.formTask.sprintId.value).pipe(first()).subscribe(response => {
        if (response.data.length > 0) {
          this.minDate = new Date(response.data[0].startDate);
          this.maxDate = new Date(response.data[0].endDate);
          this.teamId = response.data[0].teamId;
          if (this.formTask.startDate.value != null) {
            if (moment(this.minDate).isAfter(this.formTask.startDate.value, 'day')) {
              this.taskForm.patchValue({ startDate: this.minDate })
            }
          }
          if (this.formTask.endDate.value != null) {
            if (moment(this.maxDate).isBefore(this.formTask.endDate.value, 'day')) {
              this.taskForm.patchValue({ endDate: this.maxDate })
            }
          }
        }
      })
    }
  }

  loadTasksColumn(search?: any) {
      this.boardService.getTasksByColumnSprint(this.projectId,this.formTask.columnId.value, this.formTask.sprintId.value, search == null ? null : search).pipe(first()).subscribe(response => {

        this.taskColumnsList = []; 
        if (response.data.length > 0) {
          for (let x in response.data) {
            this.taskColumnsList.push({ label: response.data[x].title, value: response.data[x].id });
          }
        }
      }, error => {
        this.utilSrv.toast(`${this.translateService.instant('BOARD.ERROR.LOADCOLUMNTYPE')}: ${error}`, 'error', false);
      });
   
  }
  loadTasksSprint(search?: any) {
      this.boardService.getTasksBySprint(this.projectId, this.formTask.sprintId.value, search == null ? null : search).pipe(first()).subscribe(response => {

        this.taskSprintsList = []; 
        if (response.data.length > 0) {
          for (let x in response.data) {
            this.taskSprintsList.push({ label: response.data[x].title, value: response.data[x].id });
          }
        }
      }, error => {
        this.utilSrv.toast(`${this.translateService.instant('BOARD.ERROR.LOADSPRINTTYPE')}: ${error}`, 'error', false);
      });
   
  }

  clearAssignedTo() {
    this.usersList = [];
    this.taskForm.patchValue({ assignedId: null });
    this.minDate = null as any;
    this.maxDate = null as any;
  }

  /*Dates Validation */
  validateDates() {
    const formStart = this.taskForm.value.startDate;
    const formEnd = this.taskForm.value.endDate;
    const startDate = moment(formStart);
    const endDate = moment(formEnd);

    if (startDate.isValid() && endDate.isValid() && startDate.isAfter(endDate)) {
      this.taskForm.controls.startDate.setErrors({ 'invalid': true });
      this.taskForm.controls.endDate.setErrors({ 'invalid': true });
    } else if (this.submittedTask) {
      if (formStart === '' || !startDate.isValid()) this.taskForm.controls.startDate.setErrors({ 'invalid': true });
      if (formEnd === '' || !endDate.isValid()) this.taskForm.controls.endDate.setErrors({ 'invalid': true });
    } else {
      this.taskForm.controls.startDate.setErrors(null);
      this.taskForm.controls.endDate.setErrors(null);
    }
  }

  /*FilesModal */
  showModalFiles() {
    this.showModalRequestFiles = true;
    this.modal?.open(this.formTask.files.value);
  }

  saveNeedFiles($event: any) {
    if ($event) {
      if (this.showModalRequestFiles) {
        this.taskForm.patchValue({ files: $event.form });
        this.taskForm.patchValue({ uploadFiles: $event.upload });

        if ($event.delete.length > 0) $event.delete.forEach((f: any) => this.deleteFiles.push(f));
      }
    }
    //this.showModal = false;
    this.showModalRequestFiles = false;
  }

  /*SAve Funcitons */
  saveTask(modal: any) {
    this.submittedTask = true;
    if (this.taskForm.valid) {
      this.loading = true;
      if (this.subTask) {
        let data = {
          startDate: this.formTask.startDate.value,
          endDate: this.formTask.endDate.value,
          estimatedDuration: this.formTask.estimatedDuration.value ? moment(this.formTask.estimatedDuration.value, 'hh:mm').diff(moment("00:00 h", 'hh:mm'), 'minutes') : null,
          priorityId: this.formTask.priorityId.value,
          title: this.formTask.title.value,
          description: this.formTask.description.value,
          typeId: this.formTask.typeId.value,
          columnId: this.formTask.columnId.value == Number(-1) ? null : this.formTask.columnId.value,
          sprintId: this.formTask.sprintId.value,
          plannedTask: this.formTask.plannedTask.value,
          assignedId: this.formTask.assignedId.value,
          projectId: Number(this.projectId),
          requirementId: this.formTask.requirementId.value,
          requestedBy: this.formTask.requestedBy.value,
          tags: this.formTask.tags.value,
          bugId: this.formTask.bugId.value,
          supportId: this.formTask.supportId.value,
          isBefore: this.formTask.isBefore.value == Number(-1) ? null : this.formTask.isBefore.value,
          taskColumnId: this.formTask.taskColumnId.value,
          taskSprintId: this.formTask.taskSprintId.value,
          parentId: this.taskId,
          uploadedFiles: this.formTask.uploadFiles.value,
        }

        this.boardService.createSubtask(this.taskId, data).pipe(first()).subscribe((response) => {
          let promise = [];
          if (this.formTask.uploadFiles.value.length > 0) {
            promise = this.formTask.uploadFiles.value.map((file: File) => (this.fileSrv.uploadTaskFile(file, response.data[0].id)));
          }
          if (this.formTask.uploadFiles.value.length == 0) {
            this.successPopUp();
            this.setTaskForm();
            this.submittedTask = false;
            this.loading = false;
            this.boardMainScreen.realoadSubtasks.next(true);
            this.taskSprintsList = [];
            this.taskColumnsList = [];
            modal.close();
          } else {
            forkJoin(promise)
              .pipe(
                first(),
                finalize(() => null),
                catchError(error => {
                  this.utilSrv.toast(`${this.translateService.instant('FILES.ERRORSAVE')}: ${error}`, 'error', false);
                  return of(false);
                })
              ).subscribe((results) => {
                if (results) {
                  this.successPopUp();
                  this.setTaskForm();
                  this.submittedTask = false;
                  this.loading = false;
                  this.boardMainScreen.realoadSubtasks.next(true);
                  modal.close();
                }
              });
          }
        }, (error: any) => {
          console.error('Save Task', error);
          this.loading = false;
          this.errorPopUp();
        });
      } else {
        let data = {
          startDate: this.formTask.startDate.value,
          endDate: this.formTask.endDate.value,
          estimatedDuration: this.formTask.estimatedDuration.value ? moment(this.formTask.estimatedDuration.value, 'hh:mm').diff(moment("00:00 h", 'hh:mm'), 'minutes') : null,
          priorityId: this.formTask.priorityId.value,
          title: this.formTask.title.value,
          description: this.formTask.description.value,
          typeId: this.formTask.typeId.value,
          columnId: this.formTask.columnId.value == Number(-1) ? null : this.formTask.columnId.value,
          sprintId: this.formTask.sprintId.value,
          plannedTask: this.formTask.plannedTask.value,
          assignedId: this.formTask.assignedId.value,
          projectId: Number(this.projectId),
          requirementId: this.formTask.requirementId.value,
          requestedBy: this.formTask.requestedBy.value,
          bugId: this.formTask.bugId.value,
          supportId: this.formTask.supportId.value,
          isBefore: this.formTask.isBefore.value == Number(-1) ? null : this.formTask.isBefore.value,
          taskColumnId: this.formTask.taskColumnId.value,
          taskSprintId: this.formTask.taskSprintId.value,
          tags: this.formTask.tags.value,
          uploadedFiles: this.formTask.uploadFiles.value,
        }

        this.boardService.createTask(this.projectId, data).pipe(first()).subscribe((response) => {
          if (this.formTask.uploadFiles.value.length > 0) {
            this.formTask.uploadFiles.value.forEach((file: File) => {
              this.fileSrv.uploadTaskFile(file, response.data[0].id).pipe(first()).subscribe(() => {
              }, error => {
                console.error('Files', error);
                this.utilSrv.toast(`${this.translateService.instant('FILES.ERRORSAVE')}: ${error}`, 'error', false);
              });
            });
          }
          this.boardMainScreen.realoadTasks.next(true);
          this.successPopUp();
          this.setTaskForm();
          this.loading = false;
          this.submittedTask = false;
          this.taskSprintsList = [];
          this.taskColumnsList = [];
          modal.close();
        }, (error: any) => {
          console.error('Save Task', error);
          this.loading = false;
          this.errorPopUp();
        });
      }

    }
  }
  /*MODALS*/
  /**
  * opens modal
  * @param content modal content
  */
  openModal(value: any) {
    this.setTaskForm();
    if (value.taskId == 0) {
      if (value.projectId) {
        this.projectId = +value.projectId
      }

      if (value.sprintId != 0) {
        this.loadSprints(+value.sprintId)
      }

      if (value.statusId != 0) {
        this.loadColumns(+value.statusId)
      }

      if (value.bugId)
        this.taskForm.patchValue({ bugId: +value.bugId })

      if (value.supportId)
        this.taskForm.patchValue({ supportId: +value.supportId })


    } else {
      this.subTask = true;
      this.taskId = value.taskId;
      this.loadTask();
      // this.modalService.open(this.modalCreateTask, { modalDialogClass: 'modal-basic-title', size: 'md', scrollable: true, backdrop: 'static', keyboard: false });
    }
    this.modalRef = this.modalService.open(this.modalCreateTask, { centered: true, size: 'lg', scrollable: true, backdrop: 'static', keyboard: false });
  }

  loadTask() {
    this.boardService.getTask(this.taskId).pipe(first()).subscribe((response) => {
      let data = response.data[0];

      this.taskForm.patchValue({
        tags: data.tags,
        requestedBy: data.requestedBy,
        startDate: data.startDate ? new Date(data.startDate) : null,
        endDate: data.endDate ? new Date(data.endDate) : null,
      });

      if (data.sprint) {
        this.loadDataFilters(data.sprint.startDate, data.sprint.endDate);
      } else {
        this.minDate = new Date();
      }

      this.loadColumns(data.columnId);
      this.loadTypes(data.typeId);
      this.loadPriorities(data.priorityId);


      if (data.sprintId != null) this.loadSprints(data.sprintId);
      if (data.requirementId != null) this.loadRequirements(data.requirementId);

    }, error => {
      console.error('Load Task', error);
      this.utilSrv.toast(`${this.translateService.instant('BOARD.ERROR.LOADTASKS')}: ${error}`, 'error', false);
    });
  }

  openModalSprint() {
    //this.sprintForm?.openModal(false);
    this.boardMainScreen.openSprintForm.next(false);
  }

  closeModal(reload: boolean = false) {
    this.setTaskForm();
    this.submittedTask = false;
    this.subTask = false;
    this.taskId = 0;
    this.taskSprintsList = [];
    this.taskColumnsList = [];
    this.modalRef.close();
    if (reload) this.boardMainScreen.realoadTasks.next(true);
  }

  /*open Sub Modals */
  openModalEvent() {
    this.modalEvent?.openModal('addEvent', null, this.projectId, 'TASK');
  }
  openModalPriority() {
    this.modalPriority?.openModal('addPriority', null, this.projectId);
  }
  openModalColumn() {
    this.modalColumn?.openModal('addColumn', null, this.projectId);
  }

  /*POP UPS */
  successPopUp() {
    this.utilSrv.notify('SETTINGS.CREATED', 'success');
  }

  errorPopUp() {
    this.utilSrv.notify('SETTINGS.ERROR', 'error');
  }
}
